import { FC } from 'react';
import { EmployeeContactData } from '@pxtra-client-lib-legacy/gen';
import { DataGrid } from '../../../../lib/components/compound/dataGrid';
import { EmployeeDataGridElement } from '../shared/dataGridElement';
import { Loading } from '../../../../lib/components';

interface Props {
  data: EmployeeContactData | undefined;
}

export const ContactDataView: FC<Props> = ({ data }) => {
  return data ? (
    <DataGrid>
      <EmployeeDataGridElement data={data} field="email" xs={12} />
    </DataGrid>
  ) : (
    <Loading />
  );
};
